import { CloseIcon } from 'components/icons/CloseIcon';
import { useContext } from 'react';
import api from 'services/api';
import { MODAL_TYPES } from '../constants';
import { ModalContext } from 'context/ModalContext';

interface IRemoveProfileImage {
  selectedPerson: any;
  peopleData: any[];
  setPeopleData: any;
}

export default function RemoveProfileImage({ selectedPerson, peopleData, setPeopleData }: IRemoveProfileImage) {
  const { showModal } = useContext(ModalContext);

  const removeProfileImage = () => {
    api
      .patch(`api/zoom/event/sessions/${selectedPerson.session_id}/speakers/${selectedPerson.hash_id}/upload-photo/`)
      .then((res) => {
        const newPeopleList = peopleData.map((person: any) => {
          if (person.hash_id === res.data.hash_id) {
            return { ...person, ...res.data };
          }
          return person;
        });
        setPeopleData(newPeopleList);
        showModal(MODAL_TYPES.edit_speaker_profile, {
          selectedPerson: { ...selectedPerson, photo: res.data.photo },
          peopleData: newPeopleList,
          setPeopleData
        });
      });
  };

  const onCancel = () => {
    showModal(MODAL_TYPES.edit_speaker_profile, {
      selectedPerson,
      peopleData,
      setPeopleData
    });
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[300px] rounded-t-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Remove profile photo</span>
          <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
        </div>
        <div className="flex items-center justify-center mb-2">
          <img
            alt="remove"
            src={selectedPerson.photo}
            style={{
              height: 192,
              width: 'auto',
              margin: '0 auto',
              objectFit: 'contain'
            }}
          />
        </div>
        <p className="text-center mx-10">
          Are you sure you want to remove the speaker’s profile photo? We’ll replace it with a default one.
        </p>
      </div>
      <div className="flex text-[13px] pb-4 px-4 bg-white rounded-b-lg border-x">
        <button
          className="py-2 px-3 text-black border border-[#e7eaec] ml-auto rounded-md hover:bg-gray-200"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button className="bg-red-main py-2 px-4 text-white ml-2 rounded-md" onClick={removeProfileImage}>
          Yes, Remove Photo
        </button>
      </div>
    </div>
  );
}
